import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Checkbox,
} from '@material-ui/core'
import { useField } from 'formik'

export const FormikCheckbox = ({ fullWidth, name, value, label, ...props }) => {
  const [field, { touched, error }] = useField({
    type: 'checkbox',
    name: name,
    value: value,
  })
  const hasError = Boolean(touched && error)

  return (
    <FormControl error={hasError} fullWidth={fullWidth}>
      <FormControlLabel
        control={<Checkbox {...field} {...props} />}
        label={label}
      />
      {hasError && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  )
}

export default FormikCheckbox
